class DartyHeroSlider extends HTMLElement {
  constructor() {
    super();
    this.swiperId = this.id;
    this.swiperDiv = this.querySelector(`.${this.dataSelector}`);
    this.dataSelector = this.getAttribute("data-selector");
    this.dataTargetSelector = this.getAttribute("data-selector");
    this.dataSliderContent = this.querySelector(".hero_swiper_content");
    this.dataAutoplayDelay = this.dataset.autoplayDelay ?? 4000;
    // Swiper configuration
    this.swiperInstance;
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    // let swiperInstance;
    const initSwiperInstance = (selector) => {
      const s = document.querySelector(selector);
      if (!s) return; // Exit if the selector doesn't exist

      // Cleanup existing Swiper instance
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
      }

      // Initialize new Swiper instance
      this.swiperInstance = new Swiper(selector, this.getSwiperOptions());
    };

    // Function to create an intersection observer
    const createObserverInstance = (targetSelector, selector) => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(
          (entry) => {
            if (entry.isIntersecting) {
              console.debug("Creating instance for swiper...");
              initSwiperInstance(`.${selector}`);
              // Stop observing once initialized
              observer.unobserve(entry.target);
            }
          },
          {
            rootMargin: "100px 0px 0px 0px", // Trigger when the top of the element is in the upper half of the viewport
            threshold: 0,
          }
        );
      });

      // Start observing the specified element
      const targetElement = document.querySelector([`.${targetSelector}`]);

      if (targetElement) {
        observer.observe(targetElement);
      }
    };

    // Ensure Swiper initializes on page load
    if (document.readyState === "complete") {
      // If already loaded, initialize immediately
      createObserverInstance(this.dataTargetSelector, this.dataSelector);
    } else {
      // Otherwise, wait for the load event
      window.addEventListener("load", () => {
        createObserverInstance(this.dataTargetSelector, this.dataSelector);
      });
    }

    // Reinitialize Swiper when a section is loaded or changed in the theme editor
    document.addEventListener("shopify:section:load", (event) => {
      if (event.detail.sectionId === this.id) {
        createObserverInstance(this.dataTargetSelector, this.selector);
      }
    });

    // Cleanup Swiper instance when the section is unloaded
    document.addEventListener("shopify:section:unload", (event) => {
      if (event.detail.sectionId === this.id) {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }
    });
  }

  getSwiperOptions = () => {
    return {
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      centeredSlides: true,
      autoplay: {
        delay: this.dataAutoplayDelay,
        disableOnInteraction: false,
      },
      mousewheel: { forceToAxis: true },
      grabCursor: true,
      on: {
        slideChange: (slide) => {
          let previousContentSlide = this.dataSliderContent.children.item(
            slide.previousIndex
          );
          let activeContentSlide = this.dataSliderContent.children.item(
            slide.activeIndex
          );

          previousContentSlide.setAttribute("data-active", "false");
          activeContentSlide.setAttribute("data-active", "true");
        },
      },
    };
  };
}

customElements.define("darty-hero-slider", DartyHeroSlider);
